import { MainSongResponse } from '../../responses/responseTypes';
import { ITag, Tag } from '../tag';
import { BaseSong } from './baseSong';
import { SongType } from './enums';
import { ITagable, ISongAttributes } from './interfaces';

export class CustomizableSong
  extends BaseSong
  implements ITagable, ISongAttributes
{
  genres: Array<ITag>;

  secondaryGenres: Array<ITag>;

  moods: Array<ITag>;

  instruments: Array<ITag>;

  keys: Array<ITag>;

  energies: Array<ITag>;

  eras: Array<ITag>;

  tempoBPM: number;

  hasVocals: boolean;

  constructor(data: MainSongResponse) {
    super(SongType.CUSTOMIZABLE, data);

    this.tempoBPM = data.tempo_bpm;
    this.hasVocals = data.has_vocal;

    this.genres =
      data.genres?.map((genreData) => new Tag(genreData, 'genres')) ?? [];
    this.secondaryGenres =
      data.secondary_genres?.map((genreData) => new Tag(genreData, 'genres')) ??
      [];
    this.moods =
      data.moods?.map((moodData) => new Tag(moodData, 'moods')) ?? [];
    this.instruments =
      data.instruments?.map(
        (instrumentData) => new Tag(instrumentData, 'instruments')
      ) ?? [];
    this.keys = data.keys?.map((keyData) => new Tag(keyData, 'keys')) ?? [];
    this.energies =
      data.energies?.map((energyData) => new Tag(energyData, 'energies')) ?? [];
    this.eras = data.eras?.map((eraData) => new Tag(eraData, 'eras')) ?? [];
  }
}
